var exports = {
  "label": "xf0b3b88a--f657c4--label",
  "lock": "xf0b3b88a--f657c4--lock",
};

module.exports = exports;
